import SweetAlert from 'react-bootstrap-sweetalert'
import { useSelector } from 'react-redux'
import { loginUrlFor, withJamParams } from '../../util/recordingNavigation'

const GuestCheckoutBlockedModal = () => {
  const portal = useSelector(state => state.portal)

  const loginPath = portal.custom_login_url || 'log-in'
  const loginUrl = loginUrlFor(`/${loginPath}`, withJamParams('/cart', window.location.search))

  return (
    <SweetAlert
      title=""
      onConfirm={() => {
        window.location.href = loginUrl
      }}
      showCancel={false}
      confirmBtnText="Sign In"
      confirmBtnCssClass="mf-primary-btn"
      closeOnClickOutside={false}
    >
      Please sign in to continue. Guest checkout is not available for this store.
    </SweetAlert>
  )
}

export default GuestCheckoutBlockedModal
